import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import UserScore from '../../../models/UserScore'
import RingChart from '../reusable/RingChart'

interface Props {
  score: UserScore
}

const UserScoreView = (props: Props) => {
  const data = props.score.question_group_scores?.map((groupScore) => {
    return {
      label: groupScore.name,
      value: groupScore.score
    }
  }).sort((a, b) => {
    if (a.label < b.label) {
      return -1
    } else {
      return 1
    }
  })

  return (
    <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-between' sx={{
      width: '100%',
      height: '72px',
      backgroundColor: 'white',
      padding: '16px',
      borderRadius: '16px',
      marginTop: '16px'
    }}>
      <Typography variant='body1'>{props.score.email}</Typography>
      <Box display='flex' flexDirection='row' alignItems='center'>
        <RingChart data={data || []} diameter={56} />
        <Typography variant='h6' color='black' sx={{
          marginLeft: '12px'
        }}>{props.score.score}</Typography>
      </Box>
    </Box>
  )
}

export default UserScoreView
